import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/content', '/api')
  : 'http://localhost:8000/api';

const notificationService = {
  getNotifications: async (params = {}) => {
    const response = await axios.get(`${API_URL}/notifications/`, {
      params,
      withCredentials: true,
      headers: { 'X-CSRFToken': getCookie('csrftoken') },
    });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axios.get(`${API_URL}/notifications/unread_count/`, {
      withCredentials: true,
      headers: { 'X-CSRFToken': getCookie('csrftoken') },
    });
    return response.data.count;
  },

  markAsRead: async (notificationId) => {
    const response = await axios.post(
      `${API_URL}/notifications/${notificationId}/mark_read/`,
      {},
      {
        withCredentials: true,
        headers: { 'X-CSRFToken': getCookie('csrftoken') },
      }
    );
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axios.post(
      `${API_URL}/notifications/mark_all_read/`,
      {},
      {
        withCredentials: true,
        headers: { 'X-CSRFToken': getCookie('csrftoken') },
      }
    );
    return response.data;
  },
};

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default notificationService;
